import * as Usuario from './usuario';
import * as Cookie from './cookie';
import * as Logout from './logout';

export const Initialize = () => {
    $('.ingresar').click(function(){
        Login();
    });

    
    if (Cookie.LeerCookie('cookieLogin') != ""){
        Relogin();
    }

    Usuario.VerificarUsuario();
};

export const Login = () => {
    location.href = window.config.Statics.LoginUrl + window.btoa(location.href);
}

function Relogin(){
    var toRelogin = mustRelogin();
    console.log(toRelogin);

    if (toRelogin){
        var headers = { 'X-Token': Cookie.LeerCookie("token") || '', 'X-Value': Cookie.LeerCookie("xvalue") || '' };
        var data = {
            OrigenLoginTipoId: 1,
            AutenticacionTipoId: 1,
            IsRelogin: 1
        }
        jQuery.ajax({
            url: window.config.Statics.APILoginUrl +"/Usuario/ReLogin",
            type: 'post',
            dataType: "json",
            data: data,
            headers: headers,
            async: true,
            success: function (res, status, xhr) {
                if (res.code == "0000") {
                    var token = xhr.getResponseHeader("X-Token");
                    var xvalue = xhr.getResponseHeader("X-Value");
                    Cookie.SetToken(token);
                    Cookie.SetXValue(xvalue);
                    reMe();
                    top.frames['iLogout'].location.href = "http://passport.lanacion.com.ar/cifrador.aspx?pagina=" + window.location.origin + window.config.Statics.ReloginUrl;
                } else {
                    Logout.Logout();
                }
            },
            error: function (e) {
                console.log("error: " + e.toString());
            }
        });
    }
}

function mustRelogin() {
    var result = true;
    var millisecBeforeRelogin = window.config.Statics.ReloginValidation;
    try{
        var syncValue = Cookie.LeerCookie('syncLfLN');
        var cookieSalt = Cookie.LeerCookie('token');

        // Parseo cookie syncLfLN para que no tenga am/pm . 
        // Tengo que convertir la hora en formato de 24hrs y no de 12hrs . 
        // Cookie de ejemplo : 09/06/2017 06:52:46 p.m.
        if (syncValue.indexOf("/") > -1 && (syncValue.indexOf('a.m.') > -1 || syncValue.indexOf('p.m.') > -1)) {
            var arr_full_date = syncValue.split(" ");   // [0] : 09/06/2017 - [1] : 06:52:46 - [2] : p.m.

            // La fecha está en DD/MM/YYYY . La convierto a MM/DD/YYYY ; 
            var daysDate = arr_full_date[0];
            var arr_days = daysDate.split('/');
            var daysDate = arr_days[1] + '/' + arr_days[0] + "/" + arr_days[2];

            var time = convertTo24Hour(arr_full_date[1] + arr_full_date[2]);
            arr_full_date[1] = time;
            syncValue = daysDate + " " + arr_full_date[1]; // Vuelvo a armar la cookie con el date actualizado. 
        }
        // Fin 

        if (cookieSalt == '') {
            return false;
        }

        if (syncValue != '') {
            var syncDate = new Date(syncValue);
            if (new Date() < new Date(syncDate.getTime() - millisecBeforeRelogin)) {
                result = false;
            }
        }
    } catch (e) {
        return false;
    }
    
    return result;
}

function convertTo24Hour(time) {
    var hours = time.substr(0, 2);
    if(time.indexOf('a.m.') != -1 && hours == 12) {
        time = time.replace('12', '00');
    }
    if(time.indexOf('p.m.')  != -1 && hours < 12) {
        time = time.replace(hours, (parseInt(hours) + 12));
    }
    return time.replace(/(a.m.|p.m.)/, '');
}

function reMe() {
    var headers = { 'X-Token': Cookie.LeerCookie("token") || '', 'X-Value': Cookie.LeerCookie("xvalue") || '' };
    jQuery.ajax({
        url: window.config.Statics.APILoginUrl + "/Usuario/Me",
        type: 'post',
        dataType: "json",
        headers: headers,
        async: true,
        success: function (res, status, xhr) {
            if (res.code == "0000") {
                var usuario = JSON.parse(res.response);
                Cookie.SetupCookies(usuario.Usuario);
            }
            if (res.code != "0000") {
                Logout.Logout();
            }
        },
        error: function (e) {
            console.log("error: " + e.toString());
        }
    });
}


// WEBPACK FOOTER //
// ./Statics/scripts/common/login.js